import DOMPurify from 'dompurify'
import { Marked, Renderer } from 'marked'

const renderer = new Renderer()

// Wide tables would otherwise push the whole bubble out of the column.
renderer.table = function table({ header, rows }) {
  const inline = this.parser.parseInline.bind(this.parser)
  const head = header.map((cell) => `<th>${inline(cell.tokens)}</th>`).join('')
  const body = rows
    .map((row) => `<tr>${row.map((cell) => `<td>${inline(cell.tokens)}</td>`).join('')}</tr>`)
    .join('')
  return `<div class="markdown-table"><table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></div>`
}

const marked = new Marked({ gfm: true, breaks: true, renderer })

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank')
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

/** Model output is untrusted: it can echo anything a user or a web page fed it. */
export function renderMarkdown(text: string) {
  return DOMPurify.sanitize(marked.parse(text, { async: false }), { ADD_ATTR: ['target'] })
}
